import React from "react";

import Button from "@src/multiCustodian/components/MUI/Button/Button";
import Modal, { standardWidth } from "@src/sharedComponents/Modal/Modal";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./ErrorStateModal.module.css";

interface Props {
  closeModal: () => void;
}

const ErrorStateModal = (props: Props): JSX.Element => {
  return (
    <Modal
      closeModal={props.closeModal}
      className={styles.modal}
      modalStyle={standardWidth}
    >
      <Text variant="title2">Transfer Not Successful!</Text>

      <div className={styles.content}>
        <Text variant="body" color="textSubtle">
          Error: Please try again. If the issue persists, contact your customer
          service advisor.
        </Text>
      </div>

      <div className={styles.footer}>
        <Button
          variant={"contained"}
          buttonType={"primary"}
          text={"Ok"}
          onClick={props.closeModal}
        />
      </div>
    </Modal>
  );
};

export default ErrorStateModal;
